import styles from './ConsentCompleteStep.module.css';

function ConsentCompleteStep({ isNewConsent, onClose }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.icon}>✓</div>
      <p className={styles.title}>
        {isNewConsent ? '동의가 완료되었습니다.' : '이미 동의가 완료되어 있습니다.'}
      </p>
      <p className={styles.desc}>
        {isNewConsent
          ? '개인정보수집 및 이용 동의가 정상적으로 처리되었습니다.'
          : '이전에 개인정보수집 및 이용 동의를 완료하셨습니다.'}
      </p>
      <button className={styles.closeBtn} onClick={onClose}>확인</button>
    </div>
  );
}

export default ConsentCompleteStep;
